export default {
  color: {
    mainGreen: '#30A57D',
    mainGreenLight: '#AFD0C4',
    backgroundGreen: '#E1EFEA',
    mainRed: '#FC3B41',
    fontBlack: '#3C3C3C',
    fontDark: '#828282',
    fontNormal: '#A3A3A3',
    borderNormal: '#CCCCCC',
    borderLight: '#F1F1F1',
    backgroundLight: '#F8F8F8',
    backgroundNormal: '#F1F1F1',
    mainWhite: '#FFFFFF',
  },
  value: {
    headerHeight: '80px',
    navHeight: '75px',
    pagePadding: '20px',
  },
};
